import { combineReducers } from 'redux';
import { getSectionEnrollment, GET_SECTION_ENROLLMENT, SET_ENROLLMENT_ALERT, SET_SECTION_ENROLLMENT, STORE_ENROLLMENT } from '../actions/sections';
import { getEnrollment } from '../actions/courses';
import { createActionReducer, createFlagReducer } from '../utils/genericReducer';
import { createActionMiddleware } from '../utils/genericMiddleware';

const enrollmentRoleReducer = (state = [], action) => {
	switch(action.type) {
		case STORE_ENROLLMENT: {
            const { item } = action;
			return item
		}
		default : {
			return state;
		}
	}
}

export const sectionsReducer = combineReducers({
	enrollments: createActionReducer(GET_SECTION_ENROLLMENT),
    enrollmentRoles: enrollmentRoleReducer,
    successfullyEnrolled: createFlagReducer(SET_ENROLLMENT_ALERT)
});

const getEnrollmentUrl = (action) => {
    return {
        url: `/api/v1/sections/${action.id}/enrollments?include%5B%5D=can_be_removed`,
        method: 'GET',
        id: action.id,
        token: action.token
    }
}

const setEnrollmentUrl = (action) => {
    return {
        url: `/api/v1/sections/${action.id}/enrollments`,
        method: 'POST',
        body: action.data,
        token: action.token
    }
}

const afterResult = (store, action, res) => {
    const sectionId = res && res.data && res.data[0] && res.data[0].course_section_id;
    const token = action.token;
    const id = action.courseId;
    store.dispatch(getSectionEnrollment(sectionId, token))
    store.dispatch(getEnrollment(id, token))
}

// set up for middleware operations
// helpful for making async and api calls
export const sectionsMiddleware = [
    createActionMiddleware(GET_SECTION_ENROLLMENT, getEnrollmentUrl),
    createActionMiddleware(SET_SECTION_ENROLLMENT, setEnrollmentUrl, afterResult),
];